import { Observable, MonoTypeOperatorFunction, timer, throwError, iif } from 'rxjs';
import { retryWhen, concatMap, tap } from 'rxjs/operators';

interface IRetryStrategyConfig {
  initialInterval: number;
  maxRetries?: number;
  maxInterval?: number;

  delayFn?(iteration: number, initialInterval: number): number;
}

function exponentialDelay(iteration: number, initialInterval: number): number {
  return Math.pow(2, iteration) * initialInterval;
}

export function genericRetryStrategy<T>(
  config: number | IRetryStrategyConfig,
): MonoTypeOperatorFunction<T> {
  if (typeof config === 'number') {
    config = { initialInterval: config };
  }

  const {
    initialInterval,
    maxRetries = Infinity,
    maxInterval = Infinity,
    delayFn = exponentialDelay,
  } = config;

  return (source$: Observable<T>) => {
    let iteration = 0;

    return source$.pipe(
      retryWhen<T>((errors$) =>
        errors$.pipe(
          tap(() => iteration++),
          concatMap((error) =>
            iif(
              () => iteration > maxRetries,
              throwError(error),
              timer(Math.min(delayFn(iteration, initialInterval), maxInterval)),
            ),
          ),
        ),
      ),
      tap(() => (iteration = 0)),
    );
  };
}
